<template>
  <div id="viewdid">
      <v-container fluid grid-list-lg>

    <v-text-field
      v-model="company"
      label="company"
      disabled
      >
    </v-text-field>
    <v-text-field
      v-model="devicetype"
      label="devicetype"
      disabled
      >
    </v-text-field>
    <v-text-field
      v-model="did"
      label="did"
      disabled
      >
    </v-text-field>

    <v-text-field
      v-model="e911"
      label="e911"
      disabled
      >
    </v-text-field>
    <v-text-field
      v-model="e911address"
      label="e911address"
      disabled
      >
    </v-text-field>
    <v-text-field
      v-model="extension"
      label="extension"
      disabled
      >
    </v-text-field>
    <v-text-field
      v-model="notes"
      label="notes"
      disabled
      >
    </v-text-field>
    <v-text-field
      v-model="user"
      label="user"
      disabled
      >
    </v-text-field>

    <v-btn color="red" @click="deleteDID" >Delete</v-btn>
    <v-btn to="/" >Close</v-btn>



<v-card-text style="height: 100px; position: relative">
    <v-fab-transition>
        <v-btn
                v-bind:to="{name: 'edit', params: {did: did}}"
                v-show="!hidden"
                color="white"
                fixed
                round
                bottom
                right
                fab
              >
              <v-icon large color="green">edit</v-icon>
        </v-btn>
    </v-fab-transition>
  </v-card-text>

</v-container>
  </div>
</template>

<script>
import db from './firebaseinit'
export default {
  name: 'viewdid',
  data () {
    return {
      company: null,
      devicetype: null,
      did: null,
      e911: null,
      e911address: null,
      extension: null,
      notes: null,
      user: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    db.collection('inventory').where('did',
    '==', to.params.did).get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        next(vm => {
          vm.company = doc.data().company
          vm.devicetype = doc.data().devicetype
          vm.did = doc.data().did
          vm.e911 = doc.data().e911
          vm.e911address = doc.data().e911address
          vm.extension = doc.data().extension
          vm.notes = doc.data().notes
          vm.user = doc.data().user
        })
      })
    })
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      db.collection('inventory').where('did', '==',
      this.$route.params.did).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.company = doc.data()
          .company
          this.devicetype = doc.data()
          .devicetype
          this.did = doc.data()
          .did
          this.e911 = doc.data()
          .e911
          this.e911address = doc.data()
          .e911address
          this.extension = doc.data()
          .extension
          this.notes = doc.data()
          .notes
          this.user = doc.data()
          .user
        })
      })
    },
deleteDID () {
      if(confirm('Are you sure?')) {
      db.collection('inventory').where('did', '==',
      this.$route.params.did).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          doc.ref.delete()
          this.$router.push('/')
        })
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ViewDID.vue